/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useState, useEffect, useCallback} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "components/elements/main/index.scss";

import * as Actions from "actions";

import UserProductTrack from "components/widgets/user/UserProductTrack";
import { isLocalMarket } from "helpers/utils";

const UserProductsPageTrack = (props) => {

    const {
        bootupInfo
    } = props;

    const marketId = (isLocalMarket() ? bootupInfo.appState.subdomain_marketId : "");

  const [state] = useState({
    layoutColumns: 3,
  });

    useEffect(() => {
    document.getElementById("color").setAttribute("href", "#");
  }, []);

  return (
      <UserProductTrack {...props} marketId={marketId} colSize={state.layoutColumns} />
  );
};

UserProductsPageTrack.propTypes = {
    userMainResetSearchProducts: PropTypes.func.isRequired,
};

// Mapping Props and State.
const userProductsPageTrack = connect(
  ({ userMainProducts, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userMainProducts.reqStatus,
    isLoading: userMainProducts.isLoading,
    serviceError: userMainProducts.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserProductsPageTrack);

export default userProductsPageTrack;
